import { memo } from 'react';
import './MembershipHeaderWithStatus.scss';
import classNames from 'classnames';

const MembershipHeaderWithStatus = memo(({ subscriptionStatus, titleClassName }) => (
  <div className="MembershipHeaderWithStatus__container--header">
    <div className="MembershipHeaderWithStatus__container--header-title">
      <div className={classNames('MembershipHeaderWithStatus__container--header-title-text', titleClassName)}>Trashie Unlimited</div>
      {subscriptionStatus && (
        <div className="MembershipHeaderWithStatus__container--header-title-status">
          <div
            className="MembershipHeaderWithStatus__container--header-title-status-icon"
            style={{ backgroundColor: subscriptionStatus.color }}
          />
          <div className="MembershipHeaderWithStatus__container--header-title-status-text">{subscriptionStatus.label}</div>
        </div>
      )}
    </div>
  </div>
));

export default MembershipHeaderWithStatus;
